<template>
  <div>
    <p class="font-md">This lists all notifications no longer active. These cannot be used for any activities.</p>
    <PaginatedTable
      :fields="fields" ref='pNTable'
      :busy="isBusy"
      noResultsText="You have no Closed Notifications."
      tableId="closedNotificationsTable"
      url="/notification/myClosedNotifications"
    >
      <template v-slot:head()="data">
        {{data.label}}
      </template>
      <template #table-busy>
        <LoadingSpinner  :message="`Loading Notifications`" />
      </template>
      <template v-slot:cell(townName)="data">
        <div class="mobile-row-center">
          {{data.item.townName}}
        </div>
      </template>
      <template v-slot:cell(fonNumber)="data">
        <div class="mobile-row-center">
          {{data.item.fonNumber}}
        </div>
      </template>
      <template v-slot:cell(activeDate)="data">
        <div  v-if="data.item.statusName === 'Pending Certification' || data.item.statusName === 'Draft'" class="mobile-row-center">
        </div>
        <div v-else class="mobile-row-center">
          {{data.item.activeDate | dateString}}
        </div>
      </template>
      <template v-slot:cell(operationDate)="data">
        <div class="mobile-row-center">
          {{data.item.operationStartDate | dateString}}
          -
          {{data.item.operationEndDate | dateString}}
        </div>
      </template>
      <template v-slot:cell(activities)="data">
        <div class="mobile-row-center">
          {{data.value}}
        </div>
      </template>
      <template v-slot:cell(view)="data">
        <div class="text-right mobile-row-center">
          <router-link tag="a" size="sm" :to="`/notification/${data.item.id}`">
            View
          </router-link>
        </div>
      </template>
    </PaginatedTable>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import PaginatedTable from '@/components/common/PaginatedTable.vue';
import LoadingSpinner from '@/components/common/LoadingSpinner.vue';

export default {
  name: 'MyClosedNotifications',
  components: {
    PaginatedTable,
    LoadingSpinner,
  },
  data() {
    return {
      isBusy: false,
      fields: [
        { key: 'townName', label: 'Town' },
        { key: 'statusName', label: 'Status' },
        { key: 'fonNumber', label: 'FON Number' },
        { key: 'activeDate', label: 'Active Date' },
        { key: 'operationDate', label: 'Operation Start/End Date' },
        { key: 'activities', label: 'Activities', formatter: this.activitiesString },
        { key: 'view', label: '', stickyColumn: true },
      ],
    };
  },
  computed: {
    ...mapState(['isExtraSmall']),
  },
  watch: {
    isExtraSmall() {
      if (this.isExtraSmall) {
        // move actionField in front of basic fields
        this.shiftMobile();
      } else {
        // move actionField to end of basic fields
        const actionField = this.fields.shift();
        this.fields.push(actionField);
      }
    },
  },
  methods: {
    shiftMobile() {
      const actionField = this.fields.pop();
      this.fields.unshift(actionField);
    },
    activitiesString(value, key, item) {
      const activities = [];
      if (item.hasHarvest) activities.push('Harvest');
      if (item.hasRoadConstruction) activities.push('Road Construction');
      if (item.hasWaterCrossing) activities.push('Water Crossing');

      return activities.join(', ');
    },
  },
  created() {
    if (this.isExtraSmall) {
      // move actionField in front of basic fields
      this.shiftMobile();
    }
  },
};
</script>
